import type { SVGProps } from 'react';

interface CirclesIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

export default function CirclesIcon({
  size = 32,
  color = 'currentColor',
  ...props
}: CirclesIconProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.24 9.24989C19.24 11.0393 17.7894 12.4899 16 12.4899C14.2106 12.4899 12.76 11.0393 12.76 9.24989C12.76 7.46048 14.2106 6.00989 16 6.00989C17.7894 6.00989 19.24 7.46048 19.24 9.24989Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M22.75 19.2399C20.9606 19.2399 19.51 17.7893 19.51 15.9999C19.51 14.2105 20.9606 12.7599 22.75 12.7599C24.5394 12.7599 25.99 14.2105 25.99 15.9999C25.99 17.7893 24.5394 19.2399 22.75 19.2399Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M19.24 22.7499C19.24 24.5393 17.7894 25.9899 16 25.9899C14.2106 25.9899 12.76 24.5393 12.76 22.7499C12.76 20.9605 14.2106 19.5099 16 19.5099C17.7894 19.5099 19.24 20.9605 19.24 22.7499Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M9.25001 19.2399C7.46061 19.2399 6.01001 17.7893 6.01001 15.9999C6.01001 14.2105 7.46061 12.7599 9.25001 12.7599C11.0394 12.7599 12.49 14.2105 12.49 15.9999C12.49 17.7893 11.0394 19.2399 9.25001 19.2399Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="square"
      />
    </svg>
  );
}
